/**
 * Import api
 */
import api from '../../api';


/**
 * Define state
 * @type {{currentUserInfo: null, isAuthenticated: boolean}}
 */
const state = {
    configurationsList: []
};


/**
 * Define getters
 * @type {{}}
 */
const getters = {

};


/**
 * Define actions
 * @type {{}}
 */
const actions = {
    /**
     * Get all configurations
     * @param commit
     * @returns {Promise<void>}
     */
    async getAllConfigurations({commit}) {
        await api.getAllConfigurations()
            .then((response) => {
                commit('GET_ALL_CONFIGURATIONS_SUCCESSFULLY', response.data);
            })
    }
};


/**
 * Define mutations
 * @type {{}}
 */
const mutations = {
    /**
     * Get all configurations successfully
     * @param state
     * @param data
     * @constructor
     */
    GET_ALL_CONFIGURATIONS_SUCCESSFULLY(state, data) {
        state.configurationsList = data.data;
    }
};


/**
 * Export module
 */
export default {
    state,
    getters,
    actions,
    mutations
}
